import { render, staticRenderFns } from "./RedPack.vue?vue&type=template&id=6db37c8f&scoped=true&"
import script from "./RedPack.vue?vue&type=script&lang=js&"
export * from "./RedPack.vue?vue&type=script&lang=js&"
import style0 from "./RedPack.vue?vue&type=style&index=0&id=6db37c8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db37c8f",
  null
  
)

export default component.exports